/**
 * 안내 API(GET /pharminsight/guide) 응답 → 모달 'AI 맞춤 추천'(Figma 15:6461) 모양.
 * 구매율은 대응 필드가 없어 null. 표시할 것이 없으면 null(섹션 숨김).
 */
export const guideToReco = guide => {
  const reason = guide?.situation_text || null;
  const products = (Array.isArray(guide?.supplements) ? guide.supplements : []).slice(0, 3);
  if (!reason && products.length === 0) return null;
  return { recommendation_reason: reason, purchase_rate: null, products };
};
